import { TCommonData, TLayout, TWidgetProps } from '@libs/types';
import clsx from 'clsx';
import React from 'react';
import { TVerticalLayoutOption } from '../../types/options';
import { getInlineStyles } from '../../utils/styles';
import styles from './css/verticalLayout.module.css';

export const VerticalLayoutWide: React.FC<TWidgetProps<TCommonData, TVerticalLayoutOption> & TLayout> = ({ widget, children, margin }) => {
    const arrangement = widget.options?.arrangement ?? 'top';
    const alignment = widget.options?.alignment ?? 'start';

    const classNames = clsx(
        styles.verticalLayoutWideInner,
        widget.options?.alignment && styles[`alignment-${alignment}`],
        widget.options?.arrangement && styles[`arrangement-${arrangement}`],
    );

    return (
        <div data-test={widget.uid} className={styles.verticalLayoutWide}>
            <div className={classNames} style={getInlineStyles({ margin })}>
                {children}
            </div>
        </div>
    );
};
